export const quotes = [
  {
    author: "Abraham Lincoln",
    text: "A house divided against itself cannot stand.",
  },
  {
    author: "Abraham Lincoln",
    text: "Important principles may, and must, be inflexible.",
  },
  {
    author: "Abraham Lincoln",
    text: "I destroy my enemies when I make them my friends.",
  },
  {
    author: "Abraham Lincoln",
    text: "You have to do your own growing no matter how tall your grandfather was.",
  },
  {
    author: "Abraham Lincoln",
    text: "Most people are about as happy as they make up their minds to be",
  },
  {
    author: "Abraham Lincoln",
    text: "Most folks are about as happy as they make up their minds to be.",
  },
  {
    author: "Abraham Lincoln",
    text: "Give me six hours to chop down a tree and I will spend the first four sharpening the axe.",
  },
  {
    author: "Abraham Lincoln",
    text: "When you have got an elephant by the hind legs and he is trying to run away, it's best to let him run.",
  },
  {
    author: "Abraham Lincoln",
    text: "The best thing about the future is that it only comes one day at a time.",
  },
  {
    author: "Abraham Lincoln",
    text: "Character is like a tree and reputation like a shadow. The shadow is what we think of it; the tree is the real thing.",
  },
  {
    author: "Abraham Lincoln",
    text: "As our case is new, we must think and act anew.",
  },
  {
    author: "Abraham Lincoln",
    text: "Be sure you put your feet in the right place, then stand firm.",
  },
  {
    author: "Abraham Lincoln",
    text: "Always bear in mind that your own resolution to succeed is more important than any one thing.",
  },
  {
    author: "Abraham Lincoln",
    text: "I walk slowly, but I never walk backward.",
  },
  {
    author: "Abraham Lincoln",
    text: "Truth is generally the best vindication against slander.",
  },
  {
    author: "Abraham Lincoln",
    text: "Most folks are as happy as they make up their minds to be.",
  },
  {
    author: "Abraham Lincoln",
    text: "I will prepare and some day my chance will come.",
  },
  {
    author: "Abraham Maslow",
    text: "What is necessary to change a person is to change his awareness of himself.",
  },
  {
    author: "Aesop",
    text: "No act of kindness, no matter how small, is ever wasted.",
  },
  {
    author: "Ajahn Chah",
    text: "If you let go a little, you will have a little peace. If you let go a lot, you will have a lot of peace.",
  },
  {
    author: "Alan Watts",
    text: "No valid plans for the future can be made by those who have no capacity for living now.",
  },
  {
    author: "Albert Camus",
    text: "Autumn is a second spring when every leaf is a flower.",
  },
  {
    author: "Albert Camus",
    text: "In the depth of winter, I finally learned that there was within me an invincible summer.",
  },
  {
    author: "Albert Einstein",
    text: "God always takes the simplest way.",
  },
  {
    author: "Albert Einstein",
    text: "Learn from yesterday, live for today, hope for tomorrow.",
  },
  {
    author: "Albert Einstein",
    text: "The only real valuable thing is intuition.",
  },
  {
    author: "Albert Einstein",
    text: "Once we accept our limits, we go beyond them.",
  },
  {
    author: "Albert Einstein",
    text: "Life is like riding a bicycle. To keep your balance you must keep moving.",
  },
  {
    author: "Albert Einstein",
    text: "Feeling and longing are the motive forces behind all human endeavor and human creations.",
  },
  {
    author: "Albert Einstein",
    text: "I believe that a simple and unassuming manner of life is best for everyone, best both for the body and the mind.",
  },
  {
    author: "Albert Einstein",
    text: "Try not to become a man of success, but rather try to become a man of value.",
  },
  {
    author: "Albert Einstein",
    text: "When the solution is simple, God is answering.",
  },
  {
    author: "Albert Einstein",
    text: "A man should look for what is, and not for what he thinks should be.",
  },
  {
    author: "Albert Einstein",
    text: "Imagination is more important than knowledge. For while knowledge defines all we currently know and understand, imagination points to all we might yet discover and create.",
  },
  {
    author: "Albert Einstein",
    text: "If A is success in life, then A equals x plus y plus z. Work is x; y is play; and z is keeping your mouth shut.",
  },
  {
    author: "Albert Einstein",
    text: "Reality is merely an illusion, albeit a very persistent one.",
  },
  {
    author: "Albert Einstein",
    text: "Peace cannot be kept by force. It can only be achieved by understanding.",
  },
  {
    author: "Albert Einstein",
    text: "We cannot solve our problems with the same thinking we used when we created them.",
  },
  {
    author: "Albert Einstein",
    source: "https://en.wikiquote.org/wiki/Albert_Einstein",
    tags: "intelligence, knowledge, simplicity, understanding",
    text: "If you can't explain it simply, you don't understand it well enough.",
  },
  {
    author: "Albert Einstein",
    source: "https://www.goodreads.com/quotes/38836",
    tags: "imagination, creativity, inspiration",
    text: "Imagination is everything. It is the preview of life's coming attractions.",
  },
  {
    author: "Albert Einstein",
    source: "https://www.goodreads.com/quotes/297929",
    tags: "imagination, creativity, intelligence",
    text: "The true sign of intelligence is not knowledge but imagination.",
  },
  {
    author: "Albert Einstein",
    text: "In the middle of every difficulty lies opportunity.",
  },
  {
    author: "Albert Einstein",
    text: "Setting an example is not the main means of influencing another, it is the only means.",
  },
  {
    author: "Albert Einstein",
    text: "Logic will get you from A to B. Imagination will take you everywhere.",
  },
  {
    author: "Albert Einstein",
    text: "Great ideas often receive violent opposition from mediocre minds.",
  },
  {
    author: "Albert Einstein",
    text: "Anyone who doesn't take truth seriously in small matters cannot be trusted in large ones either.",
  },
  {
    author: "Albert Einstein",
    text: "There are only two ways to live your life. One is as though nothing is a miracle. The other is as though everything is a miracle.",
  },
  {
    author: "Albert Einstein",
    text: "One may say the eternal mystery of the world is its comprehensibility.",
  },
  {
    author: "Albert Einstein",
    text: "A person who never made a mistake never tried anything new.",
  },
  {
    author: "Albert Einstein",
    source: "https://www.goodreads.com/quotes/11458",
    tags: "talent, curious, curiosity, passion",
    text: "I have no special talent. I am only passionately curious.",
  },
  {
    author: "Albert Gray",
    text: "Winners have simply formed the habit of doing things losers don't like to do.",
    source: "https://www.goodreads.com/quotes/524224",
    tags: "winners, habit, losers",
  },
  {
    author: "Albert Schweitzer",
    text: "Do something wonderful, people may imitate it.",
  },
  {
    author: "Albert Schweitzer",
    text: "We should all be thankful for those people who rekindle the inner spirit.",
  },
  {
    author: "Albert Schweitzer",
    text: "One who gains strength by overcoming obstacles possesses the only strength which can overcome adversity.",
  },
  {
    author: "Albert Schweitzer",
    text: "Wherever a man turns he can find someone who needs him.",
  },
  {
    author: "Albert Schweitzer",
    text: "Constant kindness can accomplish much. As the sun makes ice melt, kindness causes misunderstanding, mistrust, and hostility to evaporate.",
  },
  {
    author: "Albert Schweitzer",
    text: "Success is not the key to happiness. Happiness is the key to success. If you love what you are doing, you will be successful.",
  },
  {
    author: "Albert Schweitzer",
    text: "An optimist is a person who sees a green light everywhere, while the pessimist sees only the red spotlight... The truly wise person is colour-blind.",
  },
  {
    author: "Albert Schweitzer",
    text: "Never say there is nothing beautiful in the world any more. There is always something to make you wonder in the shape of a tree, the trembling of a leaf.",
  },
  {
    author: "Aldous Huxley",
    text: "There is only one corner of the universe you can be certain of improving, and that's your own self.",
  },
  {
    author: "Aldous Huxley",
    text: "Experience is not what happens to a man. It is what a man does with what happens to him.",
  },
  {
    author: "Alexander Pope",
    text: "Do good by stealth, and blush to find it fame.",
  },
  {
    author: "Alexander Pope",
    text: "Blessed is the man who expects nothing, for he shall never be disappointed.",
  },
  {
    author: "Alexander the Great",
    text: "There is nothing impossible to him who will try.",
  },
  {
    author: "Alexis Carrel",
    text: "All great men are gifted with intuition. They know without reasoning or analysis, what they need to know.",
  },
  {
    author: "Alfred Adler",
    text: "Trust only movement. Life happens at the level of events, not of words. Trust movement.",
  },
  {
    author: "Alfred Korzybski",
    text: "There are two ways to slide easily through life: to believe everything or to doubt everything; both ways save us from thinking.",
  },
  {
    author: "Alfred Painter",
    text: "Saying thank you is more than good manners. It is good spirituality.",
  },
  {
    author: "Alfred Sheinwold",
    text: "Learn all you can from the mistakes of others. You won't have time to make them all yourself.",
  },
  {
    author: "Alfred Tennyson",
    text: "The happiness of a man in this life does not consist in the absence but in the mastery of his passions.",
  },
  {
    author: "Alfred Whitehead",
    text: "The art of progress is to preserve order amid change, and to preserve change amid order.",
  },
  {
    author: "Alice Walker",
    text: "No person is your friend who demands your silence, or denies your right to grow.",
  },
  {
    author: "Alphonse Karr",
    text: "Some people are always grumbling because roses have thorns; I am thankful that thorns have roses.",
  },
  {
    author: "Ambrose Bierce",
    text: "Speak when you are angry and you will make the best speech you will ever regret.",
  },
  {
    author: "Amelia Earhart",
    text: "Never do things others can do and will do, if there are things others cannot do or will not do.",
  },
  {
    author: "American proverb",
    text: "From little acorns mighty oaks do grow.",
  },
  {
    author: "Amiel",
    text: "Without passion man is a mere latent force and possibility, like the flint which awaits the shock of the iron before it can give forth its spark.",
  },
  {
    author: "Amy Bloom",
    text: "Love at first sight is easy to understand; its when two people have been looking at each other for a lifetime that it becomes a miracle.",
  },
  {
    author: "Amy Tan",
    text: "I am like a falling star who has finally found her place next to another in a lovely constellation, where we will sparkle in the heavens forever.",
  },
  {
    author: "Anais Nin",
    text: "Life shrinks or expands in proportion to one's courage.",
  },
  {
    author: "Anais Nin",
    text: "The possession of knowledge does not kill the sense of wonder and mystery. There is always more mystery.",
  },
  {
    author: "Anais Nin",
    text: "Dreams pass into the reality of action. From the actions stems the dream again; and this interdependence produces the highest form of living.",
  },
  {
    author: "Anais Nin",
    text: "The personal life deeply lived always expands into truths beyond itself.",
  },
  {
    author: "Anais Nin",
    text: "Age does not protect you from love. But love, to some extent, protects you from age.",
  },
  {
    author: "Anais Nin",
    text: "The dream was always running ahead of me. To catch up, to live for a moment in unison with it, that was the miracle.",
  },
  {
    author: "Anais Nin",
    text: "There is not one big cosmic meaning for all, there is only the meaning we each give to our life.",
  },
  {
    author: "Anatole France",
    text: "To accomplish great things, we must dream as well as act.",
  },
  {
    author: "Anatole France",
    text: "To accomplish great things, we must not only act, but also dream; not only plan, but also believe.",
  },
  {
    author: "Anatole France",
    text: "It is better to understand a little than to misunderstand a lot.",
  },
  {
    author: "Anatole France",
    text: "You learn to speak by speaking, to study by studying, to run by running, to work by working; in just the same way, you learn to love by loving.",
  },
  {
    author: "André Gide",
    text: "One does not discover new lands without consenting to lose sight of the shore for a very long time.",
  },
  {
    author: "André Gide",
    text: "The most decisive actions of our life... are most often unconsidered actions.",
  },
  {
    author: "Andy Rooney",
    text: "If you smile when no one else is around, you really mean it.",
  },
  {
    author: "Andy Warhol",
    text: "They say that time changes things, but you actually have to change them yourself.",
  },
  {
    author: "Angela Schwindt",
    text: "While we try to teach our children all about life, our children teach us what life is all about.",
  },
  {
    author: "Anna Pavlova",
    text: "To follow, without halt, one aim: There is the secret of success.",
  },
  {
    author: "Anne Bradstreet",
    text: "If we had no winter, the spring would not be so pleasant; if we did not sometimes taste of adversity, prosperity would not be so welcome.",
  },
  {
    author: "Anne Bronte",
    text: "All our talents increase in the using, and the every faculty, both good and bad, strengthen by exercise.",
  },
  {
    author: "Anne Frank",
    text: "We all live with the objective of being happy; our lives are all different and yet the same.",
  },
  {
    author: "Anne Frank",
    text: "How wonderful it is that nobody need wait a single moment before starting to improve the world.",
  },
  {
    author: "Anne Frank",
    text: "No one has ever become poor by giving.",
  },
  {
    author: "Anne Frank",
    text: "Parents can only give good advice or put them on the right paths, but the final forming of a persons character lies in their own hands.",
  },
  {
    author: "Anne Lamott",
    text: "Joy is the best makeup.",
  },
  {
    author: "Anne Lindbergh",
    text: "If one is estranged from oneself, then one is estranged from others too. If one is out of touch with oneself, then one cannot touch others.",
  },
  {
    author: "Anne Schaef",
    text: "Life is a process. We are a process. The universe is a process.",
  },
  {
    author: "Anne Wilson Schaef",
    text: "Trusting our intuition often saves us from disaster.",
  },
  {
    author: "Annie Dillard",
    source: "https://www.goodreads.com/quotes/530337",
    tags: "passion, try, live",
    text: "How we spend our days is, of course, how we spend our lives.",
  },
  {
    author: "Anthony D'Angelo",
    text: "Listen to your intuition. It will tell you everything you need to know.",
  },
  {
    author: "Antoine de Saint-Exupery",
    text: "It is only with the heart that one can see rightly, what is essential is invisible to the eye.",
  },
  {
    author: "Antoine de Saint-Exupery",
    text: "I know but one freedom and that is the freedom of the mind.",
  },
  {
    author: "Antoine de Saint-Exupery",
    text: "Love does not consist of gazing at each other, but in looking together in the same direction.",
  },
  {
    author: "Arie de Gues",
    text: "Your ability to learn faster than your competition is your only sustainable competitive advantage.",
  },
  {
    author: "Aristotle",
    text: "Well begun is half done.",
  },
  {
    author: "Aristotle",
    text: "Change in all things is sweet.",
  },
  {
    author: "Aristotle",
    text: "It is the mark of an educated mind to be able to entertain a thought without accepting it.",
  },
  {
    author: "Aristotle",
    text: "Happiness depends upon ourselves.",
  },
  {
    author: "Aristotle",
    text: "In all things of nature there is something of the marvellous.",
  },
  {
    author: "Aristotle",
    text: "We are what we repeatedly do. Excellence, then, is not an act, but a habit.",
  },
  {
    author: "Aristotle",
    text: "Those that know, do. Those that understand, teach.",
  },
  {
    author: "Aristotle",
    source: "https://www.goodreads.com/quotes/1309500",
    tags: "Criticism",
    text: "Criticism is something you can easily avoid by saying nothing, doing nothing, and being nothing.",
  },
  {
    author: "Aristotle",
    text: "We are what we repeatedly do. Excellence, then, is not an act but a habit.",
  },
  {
    author: "Aristotle",
    text: "Moral excellence comes about as a result of habit. We become just by doing just acts, temperate by doing temperate acts, brave by doing brave acts.",
  },
  {
    author: "Aristotle",
    source: "https://www.goodreads.com/quotes/101859",
    tags: "energy, essence, life-lessons, mind",
    text: "The energy of the mind is the essence of life.",
  },
  {
    author: "Aristotle",
    text: "If one way be better than another, that you may be sure is natures way.",
  },
  {
    author: "Arthur Conan Doyle",
    text: "Whenever you have eliminated the impossible, whatever remains, however improbable, must be the truth.",
  },
  {
    author: "Arthur Conan Doyle",
    text: "Mediocrity knows nothing higher than itself, but talent instantly recognizes genius.",
  },
  {
    author: "Arthur Rubinstein",
    text: "Of course there is no formula for success except perhaps an unconditional acceptance of life and what it brings.",
  },
  {
    author: "Arthur Schopenhauer",
    text: "Every man takes the limits of his own field of vision for the limits of the world.",
  },
  {
    author: "Arianna Huffington",
    source: "https://quotefancy.com/quote/1246163",
    tags: "Sleep, Ideas",
    text: "Discover the great ideas that lie inside you by discovering the power of sleep.",
  },
  {
    author: "Audre Lorde",
    text: "When I dare to be powerful, to use my strength in the service of my vision, then it becomes less and less important whether I am afraid.",
  },
  {
    author: "Augustinus Sanctus",
    text: "The world is a book, and those who do not travel read only a page.",
  },
  {
    author: "Babatunde Olatunji",
    text: "Yesterday is history. Tomorrow is a mystery. And today? Today is a gift. That is why we call it the present.",
  },
  {
    author: "Babe Ruth",
    text: "Yesterdays home runs don't win today's games.",
  },
  {
    author: "Baltasar Gracian",
    text: "Without courage, wisdom bears no fruit.",
  },
  {
    author: "Barack Obama",
    text: "If you're walking down the right path and you're willing to keep walking, eventually you'll make progress.",
  },
  {
    author: "Barack Obama",
    text: "Focusing your life solely on making a buck shows a poverty of ambition. It asks too little of yourself. And it will leave you unfulfilled.",
  },
  {
    author: "Barack Obama",
    text: "Change will not come if we wait for some other person or some other time. We are the ones weve been waiting for. We are the change that we seek.",
  },
  {
    author: "Barbara Baron",
    text: "Don't wait for your feelings to change to take the action. Take the action and your feelings will change.",
  },
  {
    author: "Barbara De Angelis",
    text: "We need to find the courage to say NO to the things and people that are not serving us if we want to rediscover ourselves and live our lives with authenticity.",
  },
  {
    author: "Ben Stein",
    text: "The first step to getting the things you want out of life is this: decide what you want.",
  },
  {
    author: "Ben Sweetland",
    text: "We cannot hold a torch to light another's path without brightening our own.",
  },
  {
    author: "Benjamin Disraeli",
    text: "The secret of success is constancy to purpose.",
  },
  {
    author: "Benjamin Disraeli",
    text: "Action may not always bring happiness; but there is no happiness without action.",
  },
  {
    author: "Benjamin Disraeli",
    text: "Through perseverance many people win success out of what seemed destined to be certain failure.",
  },
  {
    author: "Benjamin Disraeli",
    text: "Never apologize for showing feelings. When you do so, you apologize for the truth.",
  },
  {
    author: "Benjamin Disraeli",
    text: "One secret of success in life is for a man to be ready for his opportunity when it comes.",
  },
  {
    author: "Benjamin Disraeli",
    text: "The greatest good you can do for another is not just to share your riches but to reveal to him his own.",
  },
  {
    author: "Benjamin Disraeli",
    text: "The greatest good you can do for another is not just share your riches, but reveal to them their own.",
  },
  {
    author: "Benjamin Disraeli",
    text: "Ignorance never settle a question.",
  },
  {
    author: "Benjamin Disraeli",
    text: "Action may not always bring happiness, but there is no happiness without action.",
  },
  {
    author: "Benjamin Disraeli",
    text: "Never apologize for showing feeling. When you do so, you apologize for truth.",
  },
  {
    author: "Benjamin Disraeli",
    text: "We make our own fortunes and we call them fate.",
  },
  {
    author: "Benjamin Franklin",
    text: "Well done is better than well said.",
  },
  {
    author: "Benjamin Franklin",
    text: "One today is worth two tomorrows.",
  },
  {
    author: "Benjamin Franklin",
    text: "There never was a good knife made of bad steel.",
  },
  {
    author: "Benjamin Franklin",
    text: "Watch the little things; a small leak will sink a great ship.",
  },
  {
    author: "Benjamin Franklin",
    text: "Experience keeps a dear school, but fools will learn in no other.",
  },
  {
    author: "Benjamin Haydon",
    text: "There surely is in human nature an inherent propensity to extract all the good out of all the evil.",
  },
  {
    author: "Benjamin Spock",
    text: "Trust yourself. You know more than you think you do.",
  },
  {
    author: "Bernadette Devlin",
    text: "Yesterday I dared to struggle. Today I dare to win.",
  },
  {
    author: "George Bernard Shaw",
    text: "A life spent making mistakes is not only more honourable but more useful than a life spent in doing nothing.",
  },
  {
    author: "George Bernard Shaw",
    text: "I am of the opinion that my life belongs to the community, and as long as I live it is my privilege to do for it whatever I can.",
  },
  {
    author: "George Bernard Shaw",
    text: "We don't stop playing because we grow old; we grow old because we stop playing.",
  },
  {
    author: "George Bernard Shaw",
    source: "https://www.goodreads.com/quotes/8727",
    tags: "meaning, creativity",
    text: "Life isn't about finding yourself. Life is about creating yourself.",
  },
  {
    author: "Bernice Reagon",
    text: "Life's challenges are not supposed to paralyse you, they're supposed to help you discover who you are.",
  },
  {
    author: "Bernice Reagon",
    text: "Life's challenges are not supposed to paralyze you, they're supposed to help you discover who you are.",
  },
  {
    author: "Bertrand Russell",
    text: "The happiness that is genuinely satisfying is accompanied by the fullest exercise of our faculties and the fullest realization of the world in which we live.",
  },
  {
    author: "Betty Friedan",
    text: "It is easier to live through someone else than to become complete yourself.",
  },
  {
    author: "Bill Gates",
    source: "https://www.goodreads.com/quotes/323288",
    tags: "inspirational",
    text: "Success is a lousy teacher. It seduces smart people into thinking they can't lose.",
  },
  {
    author: "Billie Armstrong",
    text: "Our passion is our strength.",
  },
  {
    author: "Billy Wilder",
    text: "Trust your own instinct. Your mistakes might as well be your own, instead of someone elses.",
  },
  {
    author: "Bishop Desmond Tutu",
    text: "We must not allow ourselves to become like the system we oppose.",
  },
  {
    author: "Blaise Pascal",
    text: "The heart has its reasons which reason knows not of.",
  },
  {
    author: "Blaise Pascal",
    text: "Kind words do not cost much. Yet they accomplish much.",
  },
  {
    author: "Blaise Pascal",
    text: "Man is equally incapable of seeing the nothingness from which he emerges and the infinity in which he is engulfed.",
  },
  {
    author: "Blaise Pascal",
    text: "Imagination disposes of everything; it creates beauty, justice, and happiness, which are everything in this world.",
  },
  {
    author: "Blaise Pascal",
    text: "The least movement is of importance to all nature. The entire ocean is affected by a pebble.",
  },
  {
    author: "Blaise Pascal",
    text: "We are all something, but none of us are everything.",
  },
  {
    author: "Blaise Pascal",
    text: "We know the truth, not only by the reason, but by the heart.",
  },
  {
    author: "Blaise Pascal",
    text: "We must learn our limits. We are all something, but none of us are everything.",
  },
  {
    author: "Bo Jackson",
    text: "Set your goals high, and don't stop till you get there.",
  },
  {
    author: "Bob Newhart",
    text: "All I can say about life is, Oh God, enjoy it!",
  },
  {
    author: "Bodhidharma",
    text: "All know the way; few actually walk it.",
  },
  {
    author: "Booker Washington",
    text: "Excellence is to do a common thing in an uncommon way.",
  },
  {
    author: "Booker Washington",
    text: "The world cares very little about what a man or woman knows; it is what a man or woman is able to do that counts.",
  },
  {
    author: "Brendan Francis",
    text: "No yesterdays are ever wasted for those who give themselves to today.",
  },
  {
    author: "Brian Tracy",
    text: "Goals are the fuel in the furnace of achievement.",
  },
  {
    author: "Brian Tracy",
    text: "Whatever we expect with confidence becomes our own self-fulfilling prophecy.",
  },
  {
    author: "Brian Tracy",
    text: "You can only grow if you're willing to feel awkward and uncomfortable when you try something new.",
  },
  {
    author: "Brian Tracy",
    text: "There is never enough time to do everything, but there is always enough time to do the most important thing.",
  },
  {
    author: "Brian Tracy",
    source: "https://www.goodreads.com/quotes/28134",
    tags: "future, inner power",
    text: "You have within you, right now, everything you need to deal with whatever the world can throw at you.",
  },
  {
    author: "Bruce Garrabrandt",
    source:
      "https://www.google.com/search?q=Bruce+Garrabrandt+Creativity+doesn%27t+wait",
    tags: "creativity, creative, perfect, waiting, ordinary",
    text: "Creativity doesn't wait for that perfect moment. It fashions its own perfect moments out of ordinary ones.",
  },
  {
    author: "Bruce Lee",
    text: "If you spend too much time thinking about a thing, you'll never get it done.",
  },
  {
    author: "Bruce Lee",
    text: "A wise man can learn more from a foolish question than a fool can learn from a wise answer.",
  },
  {
    author: "Bruce Lee",
    text: "Notice that the stiffest tree is most easily cracked, while the bamboo or willow survives by bending with the wind.",
  },
  {
    author: "Bruce Lee",
    text: "Always be yourself, express yourself, have faith in yourself, do not go out and look for a successful personality and duplicate it.",
  },
  {
    author: "Bruce Lee",
    text: "Take no thought of who is right or wrong or who is better than. Be not for or against.",
  },
  {
    author: "Bruce Lee",
    text: "Take things as they are. Punch when you have to punch. Kick when you have to kick.",
  },
  {
    author: "Bruce Lee",
    text: "I'm not in this world to live up to your expectations and you're not in this world to live up to mine.",
  },
  {
    author: "Bruce Lee",
    text: "To know oneself is to study oneself in action with another person.",
  },
  {
    author: "Bruce Lee",
    text: "As you think, so shall you become.",
  },
  {
    author: "Bruce Lee",
    text: "Mistakes are always forgivable, if one has the courage to admit them.",
  },
  {
    author: "Bruce Lee",
    text: "If you love life, don't waste time, for time is what life is made up of.",
  },
  {
    author: "Bruce Lee",
    text: "All fixed set patterns are incapable of adaptability or pliability. The truth is outside of all fixed patterns.",
  },
  {
    author: "Bruce Lee",
    text: "The less effort, the faster and more powerful you will be.",
  },
  {
    author: "Bruce Lee",
    text: "To hell with circumstances; I create opportunities.",
  },
  {
    author: "Bruce Lee",
    text: "Im not in this world to live up to your expectations and you're not in this world to live up to mine.",
  },
  {
    author: "Bruce Lee",
    source: "https://www.goodreads.com/quotes/302319",
    tags: "knowledge, action",
    text: "Knowing is not enough, we must apply. Willing is not enough, we must do.",
  },
  {
    author: "Buckminster Fuller",
    text: "There is nothing in a caterpillar that tells you it's going to be a butterfly.",
  },
  {
    author: "Buckminster Fuller",
    source: "https://www.goodreads.com/quotes/13119",
    tags: "future, progress, reality, new",
    text: "You never change things by fighting the existing reality. To change something, build a new model that makes the existing model obsolete",
  },
  {
    author: "Buddha",
    text: "Peace comes from within. Do not seek it without.",
  },
  {
    author: "Buddha",
    text: "Work out your own salvation. Do not depend on others.",
  },
  {
    author: "Buddha",
    text: "He is able who thinks he is able.",
  },
  {
    author: "Buddha",
    text: "Those who are free of resentful thoughts surely find peace.",
  },
  {
    author: "Buddha",
    text: "What we think, we become.",
  },
  {
    author: "Buddha",
    text: "It is better to travel well than to arrive.",
  },
  {
    author: "Buddha",
    text: "The mind is everything. What you think you become.",
  },
  {
    author: "Buddha",
    text: "In separateness lies the world's great misery, in compassion lies the world's true strength.",
  },
  {
    author: "Buddha",
    text: "Happiness comes when your work and words are of benefit to yourself and others.",
  },
  {
    author: "Buddha",
    text: "Just as a candle cannot burn without fire, men cannot live without a spiritual life.",
  },
  {
    author: "Buddha",
    text: "If you light a lamp for somebody, it will also brighten your path.",
  },
  {
    author: "Buddha",
    text: "Your worst enemy cannot harm you as much as your own unguarded thoughts.",
  },
  {
    author: "Buddha",
    text: "The way is not in the sky. The way is in the heart.",
  },
  {
    author: "Buddha",
    text: "Three things cannot be long hidden: the sun, the moon, and the truth.",
  },
  {
    author: "Buddha",
    text: "You, yourself, as much as anybody in the entire universe, deserve your love and affection.",
  },
  {
    author: "Buddha",
    text: "You will not be punished for your anger, you will be punished by your anger.",
  },
  {
    author: "Buddha",
    text: "The thought manifests as the word. The word manifests as the deed. The deed develops into habit. And the habit hardens into character.",
  },
  {
    author: "Buddha",
    text: "In a controversy the instant we feel anger we have already ceased striving for the truth, and have begun striving for ourselves.",
  },
  {
    author: "Buddha",
    text: "Do not overrate what you have received, nor envy others. He who envies others does not obtain peace of mind.",
  },
  {
    author: "Buddha",
    text: "To keep the body in good health is a duty... otherwise we shall not be able to keep our mind strong and clear.",
  },
  {
    author: "Buddha",
    text: "There are only two mistakes one can make along the road to truth; not going all the way, and not starting.",
  },
  {
    author: "Buddha",
    text: "To live a pure unselfish life, one must count nothing as ones own in the midst of abundance.",
  },
  {
    author: "Buddha",
    text: "Do not dwell in the past, do not dream of the future, concentrate the mind on the present moment.",
  },
  {
    author: "Buddha",
    text: "We are what we think. All that we are arises with our thoughts. With our thoughts, we make the world.",
  },
  {
    author: "Buddha",
    text: "Your work is to discover your world and then with all your heart give yourself to it.",
  },
  {
    author: "Buddha",
    text: "All that we are is the result of what we have thought. The mind is everything. What we think we become.",
  },
  {
    author: "Buddha",
    text: "The foot feels the foot when it feels the ground.",
  },
  {
    author: "Buddha",
    text: "No one saves us but ourselves. No one can and no one may. We ourselves must walk the path.",
  },
  {
    author: "Buddha",
    text: "When you realize how perfect everything is you will tilt your head back and laugh at the sky.",
  },
  {
    author: "Buddha",
    text: "Thousands of candles can be lighted from a single candle, and the life of the candle will not be shortened. Happiness never decreases by being shared.",
  },
  {
    author: "Buddha",
    text: "He who experiences the unity of life sees his own Self in all beings, and all beings in his own Self, and looks on everything with an impartial eye.",
  },
  {
    author: "Buddha",
    text: "In the sky, there is no distinction of east and west; people create distinctions out of their own minds and then believe them to be true.",
  },
  {
    author: "Buddha",
    text: "Thousands of candles can be lit from a single, and the life of the candle will not be shortened. Happiness never decreases by being shared.",
  },
  {
    author: "Buddha",
    text: "Always be mindful of the kindness and not the faults of others.",
  },
  {
    author: "Buddha",
    text: "Better than a thousand hollow words, is one word that brings peace.",
  },
  {
    author: "Buddha",
    text: "A jug fills drop by drop.",
  },
  {
    author: "Buddha",
    text: "You only lose what you cling to.",
  },
  {
    author: "Buddha",
    text: "Every human being is the author of his own health or disease.",
  },
  {
    author: "Buddha",
    text: "Your body is precious. It is our vehicle for awakening. Treat it with care.",
  },
  {
    author: "Buddha",
    text: "Chaos is inherent in all compounded things. Strive on with diligence.",
  },
  {
    author: "Buddha",
    text: "No matter how hard the past, you can always begin again.",
  },
  {
    author: "Buddha",
    text: "Your work is to discover your work and then with all your heart to give yourself to it.",
  },
  {
    author: "Buddha",
    text: "If we could see the miracle of a single flower clearly, our whole life would change.",
  },
  {
    author: "Buddha",
    text: "You cannot travel the path until you have become the path itself.",
  },
  {
    author: "Buddha",
    text: "We are shaped by our thoughts; we become what we think. When the mind is pure, joy follows like a shadow that never leaves.",
  },
];
